import React, { Fragment, useState } from 'react'
import { Link, } from 'react-router-dom'
import './style.css'
export default function ResourcesShareCard(props) {
    const [hoverFlag, setHoverFlag] = useState(false);
    const { data } = props;
    if (data.title === "遥感地理数据检索") {
        return (
            <Fragment>
                <div className='ResourcesShareCard2' onMouseEnter={() => setHoverFlag(true)}>
                    <img className='ResourcesShareCard_BackgroundImg' src={data.address} />
                    <div className='ResourcesShareCard_Content'>
                        <div className='ResourcesShareCard_ContentTitle2'>{data.title}</div>
                        <div className='ResourcesShareCard_ContentMenu'>
                            {data.menuList.map((menu) => {
                                return <div className='ResourcesShareCard_ContentMenuText'>{menu.menuTitle}</div>
                            })}
                        </div>
                        <div className='ResourcesShareCard_ContentImg1' />
                        <div className='ResourcesShareCard_ContentImg2' />
                    </div>

                    <div className='ResourcesShareCard2_Hover' onMouseLeave={() => setHoverFlag(false)}
                        style={hoverFlag ? { opacity: 1 } : { opacity: 0 }}>
                        <img className='ResourcesShareCard_BackgroundImg_Hover'
                            style={{ background: `linear-gradient(0deg, rgba(0, 114, 229, 0.7), rgba(0, 114, 229, 0.7)),url(${data.hoverAddress})` }} />
                        <div className='ResourcesShareCard_Content_Hover'>
                            <div className='ResourcesShareCard_ContentTitle2_Hover'>{data.title}</div>
                            <div className='ResourcesShareCard_ContentMenu_Hover'>
                                {data.menuList.map((menu) => {
                                    return (
                                        <Link to={data.location}>
                                            <div className='ResourcesShareCard_ContentMenuText_Hover'>{menu.menuTitle}</div>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
    else return (
        <div className='ResourcesShareCard'>
            <img className='ResourcesShareCard_BackgroundImg' src={data.address} />
            <Link to={data.location}>
                <div className='ResourcesShareCard_Content'>
                    <div className='ResourcesShareCard_ContentTitle'>{data.title}</div>
                    <div className='ResourcesShareCard_ContentIntroduce'>{data.introduce}</div>
                </div>
            </Link>
        </div>
    )

}